import React from 'react';

export function Logo({
  size = 'normal',
  variant = 'default',
  theme = 'light'
}: {
  size?: 'small' | 'normal' | 'large';
  variant?: 'default' | 'headerCompact';
  theme?: 'light' | 'dark';
}) {
  const dimensions = {
    small: {
      width: 24,
      height: 24,
      text: 'text-lg'
    },
    normal: {
      width: 32,
      height: 32,
      text: 'text-xl'
    },
    large: {
      width: 48,
      height: 48,
      text: 'text-3xl'
    }
  };
  const { height, text } = dimensions[size];

  const textClass = variant === 'headerCompact' ? 'text-[15px] md:text-[18px] font-bold' : text;
  const iconHeight = height;

  // Responsive sizing for headerCompact variant
  const responsiveHeightCls = variant === 'headerCompact'
    ? 'h-4 sm:h-5 md:h-6 lg:h-7 xl:h-8'
    : `h-${iconHeight}`;

  return (
    <div className={`inline-flex items-center whitespace-nowrap leading-none select-none`}>
      <div className="relative">
        <img
          src={`${import.meta.env.VITE_APP_WEBSITE_URL}/logo-dark.png`}
          alt="Stock Fortress Logo"
          className={`${textClass} ${responsiveHeightCls} w-auto block`}
        />
      </div>
    </div>
  );
}